{
	"title": "Acces interzis (403)",
	"description": "Nu ai drepturile necesare pentru a accesa această pagină. Te rugăm să te asiguri că ești autentificat(ă) într-un cont cu permisiunile corespunzătoare. Ștergerea datelor din browser poate rezolva, de asemenea, problema. Dacă ai în continuare nevoie de acces, te rugăm să contactezi administratorul de sistem.",
	"secondaryButtonTitle": "Deconectare"
}
